"use client"

import { createContext, useContext, useEffect, useState } from "react"

interface ScrollContextType {
  isScrolled: boolean
}

const ScrollContext = createContext<ScrollContextType>({ isScrolled: false })

export function useScrollState() {
  return useContext(ScrollContext)
}

interface ScrollAwareWrapperProps {
  children: React.ReactNode
}

export function ScrollAwareWrapper({ children }: ScrollAwareWrapperProps) {
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY
      setIsScrolled(scrollTop > 50) // Add blur after scrolling 50px
    }

    window.addEventListener("scroll", handleScroll, { passive: true })
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return (
    <ScrollContext.Provider value={{ isScrolled }}>
      {children}
    </ScrollContext.Provider>
  )
}
